<template>
  <main class="main">
    <place-in-order-modal ref="pinm"/>
    <loading-container :loading="loading" >
      <div class="worker" style="position: relative">
        <div class="worker-header">
            <div class="hitem">
              <div class="menu" @click="$router.push('/items')">
                <img src="../../assets/icons/menu.svg" alt="">Весь каталог
              </div>
              <div class="hinputs no ">
                <app-select :options="itms" :value="this.itm" @input="changeCategory($event)" placeholder="Категории"/>
              </div>
              <div class="hinputs no ">
                <app-select :options="providers" @input="changeProvider($event)" :value="this.provider" placeholder="Поставщик"/>
              </div>
              <div class="hinputs no">
                <app-select :options="types" :search="true" @input="changeBrand($event)" :value="this.brand" placeholder="Бренд"/>
              </div>
<!--              <div class="like"><img src="../../assets/icons/heart.svg" alt=""> <div class="indicator">6</div></div>-->
<!--              <div class="comparison"><img src="../../assets/icons/comparison-green.svg" alt=""> <div class="indicator">9</div></div>-->
            </div>
          </div>
        <div class="worker-header">
          <!--<label class="worker-checkbox">
            <input type="checkbox">
            <span class="checkmark"></span>
            Есть договор с поставщиком
          </label>-->
          <!--<div class="tabs">
            <div
                class="tabs-item"
                v-for="(item) in tabs"
                :class="{active: tab == item.key}"
                :key="item.key"
                @click="tab = item.key"
            >
              <div class="category">{{item.title}}</div>
            </div>
          </div>-->


        </div>
        <!--<h4>Параметры заказа</h4>
        <div class="worker-header">
          <div class="hitem">
            <div class="hinputs no mr">
              <app-select :options="itm"  placeholder="Моу Юр.Лицо"/>
            </div>

            <div class="hinputs no">
              <app-select :options="addresses" v-validate="'required'" name="address" @input="address = $event" placeholder="Адрес"/>
              <span class="text-danger text-sm address-error">{{ errors.first('address') }}</span>
            </div>

          </div>
        </div>-->
        <div class="wrap">
          <div class="col-4">
            <div class="card white">
              <div class="title">Ваш заказ</div>
              <div class="sum">{{count}} {{declOfNum(count, ['артикул', 'артикула', 'артикулов'])}} на {{total_sum | currency}}</div>
              <app-button class="mt-auto" @click="createOrder()" :disabled="!items.length">Сформировать заказы</app-button>
            </div>
          </div>
          <div class="col-4 g">
            <div class="card">
              <div class="title">Поставщики</div>
              <div class="sup"
                   v-for="(item, idx) in suppliers"
                   :key="'provider-' + idx">
                <div class="item">
                  <div class="name">{{idx}}</div>
                  <div class="verif" v-if="item.verif"><img src="../../assets/icons/verification.svg" alt=""></div>
                  <div class="price text-right">{{item | currency}}</div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-4 g">
            <div style="margin-top: 110px;" v-if="$store.getters.getCompany.dropshipping">
              <app-checkbox v-model="dropshipping">Заказ по дропшиппингу</app-checkbox>
            </div>
          </div>
          <!--<div class="col-4 g">
            <div class="card">
              <div class="title">Юр лица</div>
              <div class="sup"
                   v-for="(item, idx) in entity"
                   :key="idx">
                <div class="item">
                  <div class="name">{{item.name}}</div>
                  <div class="verif" v-if="item.verif"><img src="../../assets/icons/verification.svg" alt=""></div>
                  <div class="price">{{item.price}} Р</div>
                </div>
              </div>
            </div>
          </div>-->
        </div>
        <div class="info">
<!--          <img src="../../assets/icons/verification.svg" alt=""> - есть договор с поставщиком-->
<!--          <img src="../../assets/icons/package.svg" class="order" alt=""> - заказ только в упаковках-->
        </div>
        <loading-container :loading="loading2" height="99">
          <div class="table">
            <table class="worker-table">
              <tr>
                <th>Фото</th>
                <th>Артикул</th>
                <th>Наименование товара</th>
                <th>Цвет</th>
                <th>Размер</th>
                <th>Бренд</th>
                <th>Штук в уп-ке</th>
                <th>Цена за шт. руб.</th>
                <!--<th>Остаток Поставщика</th>
                <th>Оплата</th>-->
                <th>Поставщик</th>
<!--                <th>Категория</th>-->
                <th>Тип товара</th>
                <th>Остаток <br>поставщика</th>
                <th v-if="$store.getters.getCompany.dropshipping && dropshipping">Дропшиппинг</th>
                <th>Мой заказ</th>
                <th width="120px">Сумма, руб.</th>
                <th></th>
              </tr>
              <tr v-for="(item, idx) in items" :key="idx" :class="{active: item.order >= 1, danger: checkQuantity(item.quantity, item.basket.count)}">
                <td class="ta-center"><img class="photo" v-if="item.image != null" :src="item.image != null ? item.image.image : ''" alt=""></td>
                <td>{{item.article}}</td>
                <td width="200px">
                  <router-link style="color:#2CB181" :to="'product/' + item.id">
                    {{item.name}}
                  </router-link>
                </td>
                <td>{{ item.main_attr != null && item.main_attr.color ?  item.main_attr.color : '' }}</td>
                <td>{{ item.main_attr != null && item.main_attr.size ?  item.main_attr.size : '' }}</td>
                <td>{{ item.main_attr != null && item.main_attr.brand ? item.main_attr.brand : '' }}</td>
                <td>{{item.main_attr != null ? item.main_attr.count_in_pkg : ''}}</td>
                <td class="green text-right" style="min-width: 112px;">{{item.price_opt | currency}}</td>
                <!--<td style="display: flex"> <div class="green">{{item.quantity}}</div></td>
                <td>30 КД</td>-->
                <td>{{item.company.name}}</td>
<!--                <td>{{item.category.name}}</td>-->
                <td>
                  <product-labels :labels="item.labels" />
                </td>
                <td>{{item.quantity}}</td>
                <th style="text-align: center;" v-if="$store.getters.getCompany.dropshipping && dropshipping">{{item.dropshipping ? 'Да' : 'Нет'}}</th>
                <td width="40px">
                  <app-chevron-counter v-model="item.basket.count" @keyup="changeCount(idx)"/>
                </td>
                <td class="black text-right" style="min-width: 112px;">{{item.price_opt * item.basket.count | currency}}
                  <!--<div class="inf"><img src="../../assets/icons/verification.svg" alt="">
                    <img src="../../assets/icons/package.svg" alt="">
                  </div>-->
                </td>
                <td class="action">
                    <button @click="deleteProduct(item.id, idx)">
                        <img class="hover_btn" src="@/assets/img/worker/delete.svg" alt="">
                    </button>
                </td>
              </tr>
            </table>
          </div>
        </loading-container>
        <div class="wrap">
          <pagination
              v-show="last_page > 1"
              v-model="page"
              :page-count="last_page"
          />
          <div class="sort">Выводить по:</div>
          <div class="sorting">
            <template v-for="item in sorting" >
              <div class="butn"
                   :key="item.key"
                   @click="changePerPage(item.key)"
                   :class="{active: per_page == item.key}"
              >
                {{item.content}}
              </div>
            </template>

          </div>
        </div>
      </div>
    </loading-container>
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import Pagination from "@/components/pagination";
import PlaceInOrderModal from "@/components/modals/place-in-order-modal";
import AppChevronCounter from "@/components/app-chevron-counter";
import AppSelect from "@/components/app-select";
import AppButton from "@/components/app-button";
import AppCheckbox from "@/components/app-checkbox";
import ProductLabels from "@/components/product-labels";

export default {
  name: "order",
  components: {
    AppButton,
    AppChevronCounter,
    PlaceInOrderModal,
    LoadingContainer,
    Pagination,
    AppSelect,
    AppCheckbox,
    ProductLabels
  },
  data: ()=>({
    loading: true,
    loading2: false,
    providers: [],
    itms: [],
    itm: null,
    last_page: 5,
    count: 0,
    sum: 0,
    total_sum: 0,
    items: [],
    page: 1,
    per_page: 30,
    address: '',
    dropshipping: false,
    sorting: [
      {
        key: 30,
        content: '30'
      },
      {
        key: 50,
        content: '50'
      },
      {
        key: 100,
        content: '100'
      },
      {
        key: 200,
        content: '200'
      },
    ],
    sort: 0,
    brands: ['Бренд 1', 'Бренд 2'],
    suppliers: [],
    entity: [
      {
        name:'ООО "Лес"',
        verif: 0,
        price: '1200'
      },
      {
        name:'ООО "Удочки у дома"',
        verif: 0,
        price: '300'
      },

    ],
    types: [],
    tabs: [
      {
        title: "Новые",
        key: 0,
      },
      {
        title: "Популярные",
        key: 1,
      },
      {
        title: "Дешевые",
        key: 2,
      },
      {
        title: "Дорогие",
        key: 3,
      },

    ],
    tab: 0,
    provider: '',
    brand: '',
  }),
  mounted() {
    this.getItems();
    this.getBrand();
    /*this.getCategories();*/
  },
  methods: {
    getBrand() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-basket-brands', {
          token: localStorage.getItem('token'),
        }).then(({data}) => {
          if (data.brand) {
            this.types = data.brand;
          }
        }).catch((error) => {
            console.log(error)
        })
      }
    },
    getItems() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-basket-items', {
          token: localStorage.getItem('token'),
          per_page: this.per_page,
          page: this.page,
          provider: this.provider ? this.provider.id : '',
          brand: this.brand ? (this.brand.label == 'Все' ?  '' : this.brand.id) : '',
          itm: this.itm ? this.itm.id : ''
        }).then(({data}) => {
          if (data.items) {
            this.items = data.items.data;
            this.last_page = data.items.last_page;
            this.suppliers = data.info.companies;
            this.count = data.info.count;
            this.sum = data.info.sum;
            this.total_sum = data.info.total_sum;
            this.dropshipping = data.info.dropshipping;

            if (data.info.providers && this.providers.length == 0) {
              for (let key in data.info.providers) {
                this.providers.push({id: data.info.providers[key].id, label: data.info.providers[key].company.name});
              }
            }
            if (data.info.categories && this.itms.length == 0) {
                for (let key in data.info.categories) {
                  this.itms.push({id: data.info.categories[key].id, label: data.info.categories[key].name});
                }
            }
          }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(()=> {this.loading = false; this.loading2 = false})
      }
    },
    changePerPage(val) {
      this.per_page = val;
      if (this.page === 1) {
        this.loading2 = true;
        this.getItems();
      } else {
        this.page = 1;
        this.loading2 = true;
        this.getItems();
      }
    },
    deleteProduct(id, key) {
      this.$http.post('/delete-basket-item', {
        token: localStorage.getItem('token'),
        id: id,
      }).then(({data}) => {
        if (data.info) {
          this.providers = [];
          this.suppliers = data.info.companies;
          this.count = data.info.count;
          this.sum = data.info.sum;
          this.total_sum = data.info.total_sum;
          this.items.splice(key, 1);
          this.$toast.success('Товар успешно удален!');
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    createOrder() {
      if(this.items.length > 0) {
        this.$http.post ( '/create-order',{
          token: localStorage.getItem('token'),
          dropshipping: this.dropshipping ? 1 : 0
        })
            .then(({data}) => {
              if(data.success){
                this.$toast.error("Заказ успешно сформирован! Проверьте и отправьте поставщику", {duration: 120000});
                if(localStorage.getItem('type' ) == 2){
                  if (this.dropshipping) {
                      this.$router.push({name: 'dropur'});
                  } else {
                      this.$router.push({name: 'opur'});
                  }
                }
              }

              if(data.error){
                this.$toast.error(data.error);
              }
            })
            .catch((error) => {console.log(error)})
      }else{
        this.$toast.warning('Список заказов пустой!')
      }
    },
    getCategories() {
      this.itm = [];
      this.$http.post ( '/get-all-categories',{token: localStorage.getItem('token')})
          .then(({data}) => {
            if (data.categories) {
              for (let key in data.categories[0].children) {
                for (let k in data.categories[0].children[key].children) {
                  this.itms.push({id: data.categories[0].children[key].children[k].id, label: data.categories[0].children[key].children[k].name});
                }
              }
            }
            console.log(data.categories)
          })
          .catch((error) => {console.log(error)})
    },
    changeCount(key) {
      if (this.items[key].basket.count < 1) {
        this.items[key].basket.count = 1;
      }

      this.$http.post('/change-count-basket-item', {
        token: localStorage.getItem('token'),
        id: this.items[key].id,
        count: this.items[key].basket.count,
        }).then(({data}) => {
          if (data.info) {
            this.suppliers = data.info.companies;
            this.count = data.info.count;
            this.sum = data.info.sum;
            this.total_sum = data.info.total_sum;
          }
        })
        .catch((error) => {
            console.log(error)
        })
    },
    declOfNum(n, text_forms) {
      n = Math.abs(n) % 100; var n1 = n % 10;
      if (n > 10 && n < 20) { return text_forms[2]; }
      if (n1 > 1 && n1 < 5) { return text_forms[1]; }
      if (n1 == 1) { return text_forms[0]; }
      return text_forms[2];
    },
    changeProvider(val) {
      this.loading2 = true;
      this.provider = val;
      this.page = 1;
      this.getItems();
    },
    changeCategory(val) {
      this.loading2 = true;
      this.itm = val;
      this.page = 1;
      this.getItems();
    },
    changeBrand(val) {
      this.loading2 = true;
      this.brand = val;
      this.page = 1;
      this.getItems();
    },
    checkQuantity(quantity, count) {
      if (quantity) {
        quantity = Number(quantity);
        if (Number.isInteger(quantity) && count > quantity) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    page: function (val) {
      if (val >= 1) {
        this.loading2 = true;
        this.getItems();
      }
    }
  }
}
</script>

<style>
.ta-center {
  text-align: center !important;
  vertical-align: middle !important;
}
.danger {
  background-color: rgba(255,123,91, 0.2) !important;
}
.v-select{
  margin: 0 !important;
}
</style>
<style scoped lang="scss">

.main {
  width: 87%;
  overflow: hidden;
}

.address-error {
  position: absolute;
  top: 38px;
}
.table{
  border-collapse: collapse;
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border: 1px #EEF0F3 solid;
  border-radius: 5px;
  tr {
    &:nth-child(even) {
      background: #F9F9FB;
    }
  }
  th, td {
    .green{
      color: #2CB181;
    }
    &.black{
      color: black;
      width: 150px;
      font-weight: 600;
    }
    .inf{
      margin-left: auto;
      img{
        margin-left: 5px;
      }
    }
    flex-wrap: wrap;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 7px 14px;
    height: 40px;
    text-align: left;

    &:not(:last-child) {
      border-right: 1px #a3a3a3 solid;
    }
  }
  th {
    color: #2D3137;
  }
  td{
    input{
      width: 40px;
      background: #FFFFFF;
      border: 1px solid #EEF0F3;
      border-radius: 4px;
      height: 30px;
      &:focus{
        border: 1px solid #2CB181;
      }
    }
  }
  tr {
    color: #7A818F;
    &.active{
      background: #E7FFF0;
      input{
        border: 1px solid #2CB181;
      }
    }
  }
  img{
    &.photo{
      max-height: 40px;
      max-width: 40px;
    }
  }
}
.sort{
  margin-left: auto;
  margin-top: 12px;
  margin-right: 15px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #7A818F;
}
.sorting {
  font-size: 0;
  line-height: 1;
  white-space: nowrap;
  display: flex;

  .butn {
    color: #7A818F;
    background: transparent;
    border: 1px solid #B6BCC8;
    border-left-width: 0;
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    padding: 11px 18px;
    outline: 0;

    &:first-child {
      border-left-width: 1px;
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }

    &:hover {
      background-color: rgba(44,177,129,0.05);
      color: #2CB181;
    }
    &.active {
      border: 1px solid #2cb181;
      color: #2CB181;
    }

    &.disabled {
      cursor: unset;
    }
  }
}
.col-4{
  padding: 0;
  &.g{
    padding-left:15px;
  }
}
h4{
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #2D3137;
}
.info{
  display: flex;
  align-items: center;
  margin: 20px 0;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  color: #7A818F;
  img{
    margin-right: 6px;
    &.order{
      margin-left: 20px;
    }
  }
}
.wrap{
  display: flex;
  .card{
    height: 130px;
    width: 100%;
    background: #EEF0F3;
    border-radius: 4px;
    border: none;
    padding: 20px;
    .title{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #7A818F;
      margin-bottom: 5px;
    }
    .sup{
      width: 100%;
      .item{
        display: flex;
        align-items: center;
        border-bottom: 1px solid #D5D9E0;
        .name{
          margin-right: auto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 134.69%;
          color: #2D3137;
        }
        .price{
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          color: #2D3137;
          width: 140px;
          text-align: right;
        }
      }
    }
    .sum{
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #2D3137;
    }
    &.white{
      background: #FFFFFF;
      box-shadow: 0px 0px 3px #E5E5EA;
    }
    &.mr{
      margin: 0 13px;
    }
  }
}
.worker {
  position: relative !important;
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .menu{
      display: flex;
      align-items: center;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      color: #2D3137;
      //margin-right: auto;
      &:hover{
        cursor: pointer;
      }
      img{
        margin-right: 7px;
      }
    }
    .like{
      margin-left: 30px;
      margin-right: 15px;
      position: relative;
    }
    .comparison{
      position: relative;
    }
    .indicator{
      height: 16px;
      width: 16px;
      background: #F39220;
      border: 1px solid #F9F9FB;
      position: absolute;
      bottom: -5px;
      left: calc(50% - 8px);
      font-style: normal;
      font-weight: 500;
      font-size: 9px;
      line-height: 9px;
      text-align: center;
      color: #FFFFFF;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .hitem{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .hinputs {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      margin: 0;
      &.no{
        max-width: 26%;
      }
      &.mr{
        margin-right: 15px;
      }
      div {
        width: 100%;
      }
      input {
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 4px;
        font-size: 12px;
        width: 100%;
        height: 40px;
        padding: 0 40px 0 15px;
        outline: none;
      }

      > img {
        position: absolute;
        right: 15px;
        bottom: 50%;
        transform: translateY(50%);
        width: 14px;
        height: 14px;
      }
      &-navigation{
        width: 60%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 8px 0 0;
        background-color: #FFFFFF;
        border-radius: 0px;
        button{
          height: 40px;
          border: none;
          outline: none;
          width: 100%;
          background-color: #FFFFFF;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #7A818F;
          cursor: pointer;
          padding: 0 15px;
          margin: 2px 0;
          border-radius: 0px;
        }
        .active{
          background: #EEF0F3;
          border-radius: 4px;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #2D3137;
          margin: 0 -5px;
        }
        hr{
          height: 20px;
          border: 1px solid #EEF0F3;
        }
      }
    }
  }
}
.tabs{
  display: flex;
  align-items: center;
  margin-left: auto;
  &-item {
    cursor: pointer;
    margin-left: 15px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    &.active {
      color: #2CB181;
      &:hover{
        color: #2CB181;
        cursor: auto;
      }
    }
    &:hover{
      color: #7dc1a8;
    }
  }
}

.action {
    button {
        height: 20px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        width: 20px;

        > img {
              width: 100%;
              height: 100%;
        }
    }
}
</style>
